import React from 'react'
import { USER_ROLES } from '@helpers/constants'
import OnboardingProgressBlock from '@components/OnboardingProgressBlock'
import OnboardingCarousel from '@components/OnboardingCarousel'
import StartpageBlocks from '@components/StartpageBlocks'
import { useCurrentUser } from '@hooks/useCurrentUser'

const Home = () => {
  const { currentUser } = useCurrentUser()

  return (
    <>
      <div className={'w-full'}>
        <OnboardingCarousel />

        {/* 17 dec 2024, disabeling OnboardingProgressBlock */}
        {/* {currentUser?.userRole !== USER_ROLES.STUDENT && (
          <OnboardingProgressBlock />
        )} */}
      </div>

      <StartpageBlocks />
    </>
  )
}

export default Home
